import {
  isIOS,
  getWinWidth
} from 'core_modules/bootstrap/browsers/browser-detection';

const DRAWER_OPEN_CLS_NAME = 'isAccordionDrawerOpen';

export const drawerOpenCloseHandler = (isDrawerOn = false) => {
  if (typeof window === 'undefined') {
    return;
  }

  const eleMain = document.getElementById('responsiveWrapper_main');

  if (eleMain) {
    if (isDrawerOn) {
      eleMain.classList.add(DRAWER_OPEN_CLS_NAME);
    } else {
      eleMain.classList.remove(DRAWER_OPEN_CLS_NAME);
    }
  }
};

export const onStickyBarCtaClick = () => {
  /*
  US3635932:
  (1) With the Accordion.Drawer's presence,
      the subsequent modal's scroll is locked.  
  (2) This is an unique iOS mobile issue.
  */

  const winWidth = getWinWidth();

  if (!isIOS() || winWidth >= 768) {
    return;
  }

  const backCta = document.querySelector('button[class*="_backButton_"]');

  if (backCta) {
    backCta.click();
  }
};
